{
    "translation": {
        "welcome": "Bem-vindo",
        "home": "Início",
        "find_pro": "Encontrar Profissional",
        "admin": "Admin",
        "my_space": "Meu Espaço",
        "login": "Entrar",
        "logout": "Sair",
        "search_placeholder": "Cabeleireiro, Barbeiro, Manicure...",
        "hero_welcome": "Bem-vindo ao OpenGlow",
        "hero_slogan": "A excelência ao alcance da sua mão.",
        "hero_desc": "Reserve os seus tratamentos de beleza e bem-estar em poucos cliques. Simples, rápido e elegante.",
        "hero_title": "Agende seu horário de beleza",
        "hero_subtitle": "Encontre os melhores profissionais perto de você.",
        "search_btn": "Pesquisar",
        "popular_services": "Serviços Populares",
        "footer_rights": "Todos os direitos reservados.",
        "footer_about_us": "Quem somos",
        "legal_mentions": "Menções Legais",
        "cgp": "Condições Gerais de Prestação",
        "feature_search_title": "Pesquisar",
        "feature_search_desc": "Encontre os melhores salões e especialistas perto de você",
        "feature_book_title": "Agendar",
        "feature_book_desc": "Escolha seu horário ideal em segundos",
        "feature_enjoy_title": "Aproveitar",
        "feature_enjoy_desc": "Viva uma experiência de beleza única e relaxante",
        "featured_pros_title": "Profissionais em Destaque",
        "reviews_count": "avaliações",
        "client_space": "ÁREA DO CLIENTE",
        "my_bookings": "Minhas Reservas",
        "explore_map": "Explorar Mapa",
        "edit_photo": "Editar Foto",
        "photo_updated": "Foto de perfil atualizada!",
        "error_upload": "Erro ao carregar a foto.",
        "search_action": "Pesquisar",
        "filters_all": "Todos",
        "filter_sort": "Filtros",
        "filter_distance_nearest": "Distância: mais perto",
        "filter_rating_highest": "Avaliação: melhor",
        "filter_reviews_most": "Avaliações: mais numerosas",
        "filter_name_az": "Nome: A-Z",
        "filter_min_rating": "Avaliação mínima",
        "filter_max_distance": "Distância máxima",
        "show_filters": "Mostrar filtros",
        "hide_filters": "Ocultar filtros",
        "map_style": "Estilo",
        "map_enable_location_filter": "Ative a localização para filtrar por distância",
        "profession_hairdresser": "Cabeleireiro",
        "profession_esthetician": "Esteticista",
        "profession_barber": "Barbeiro",
        "profession_manicure": "Manicure",
        "profession_masseur": "Massagista",
        "settings_title": "Configurações",
        "settings_back": "Voltar",
        "settings_section_appearance": "Aparência",
        "settings_theme_intro": "Escolha o tema da aplicação.",
        "settings_theme_classic": "Preto & Branco",
        "settings_theme_ocean": "Oceano",
        "settings_theme_rose": "Rosa",
        "settings_theme_dark": "Escuro",
        "settings_theme_night": "Noite",
        "settings_compact_mode": "Modo compacto",
        "settings_compact_mode_sub": "Reduz o espaçamento desta página",
        "settings_section_notifications": "Notificações",
        "settings_notif_email": "Emails de reserva",
        "settings_notif_email_sub": "Confirmações e lembretes de consultas",
        "settings_notif_push": "Centro de notificações",
        "settings_notif_push_sub": "Alertas na aplicação",
        "settings_notif_marketing": "Novidades & ofertas",
        "settings_notif_marketing_sub": "Atualizações de produto e promoções",
        "settings_section_account": "Conta",
        "settings_account_profile": "Perfil",
        "settings_account_email_label": "Endereço de email",
        "settings_not_connected": "Não conectado",
        "settings_section_security": "Segurança",
        "settings_pwd_title": "Alterar senha",
        "settings_pwd_hint": "Escolha uma senha forte (12+ car., maiúscula, número, símbolo)",
        "settings_pwd_current": "Senha atual",
        "settings_pwd_new": "Nova senha",
        "settings_pwd_confirm": "Confirmar nova senha",
        "settings_pwd_submit": "Guardar senha",
        "settings_pwd_submitting": "A guardar…",
        "about_title": "Quem somos",
        "about_intro": "A OpenGlow e uma plataforma francesa que simplifica a ligacao entre clientes e profissionais de beleza.",
        "about_mission_title": "Nossa missao",
        "about_mission_text": "Ajudar cada pessoa a encontrar rapidamente um profissional de confianca perto de si, com uma experiencia de reserva simples, transparente e moderna.",
        "about_build_title": "O que estamos construindo",
        "about_build_item_1": "Um espaco de cliente claro para pesquisar, reservar e acompanhar consultas.",
        "about_build_item_2": "Um espaco profissional para gerir agenda, servicos, avaliacoes e anuncios.",
        "about_values_title": "Nossos valores",
        "about_values_simple_label": "Simplicidade:",
        "about_values_simple_text": "uma interface rapida de compreender para todos.",
        "about_values_trust_label": "Confianca:",
        "about_values_trust_text": "informacoes claras e perfis verificados.",
        "about_values_respect_label": "Respeito:",
        "about_values_respect_text": "protecao de dados pessoais e abordagem responsavel.",
        "about_values_exigence_label": "Exigencia:",
        "about_values_exigence_text": "melhoria continua da experiencia do utilizador.",
        "about_contact_title": "Contato",
        "about_contact_line_1": "Tem uma pergunta ou precisa de ajuda?",
        "about_contact_line_2": "Use o chat interno do site para uma resposta mais rapida.",
        "about_contact_line_3": "Para qualquer outra solicitacao, escreva para",
        "settings_show_pwd": "Mostrar",
        "settings_hide_pwd": "Ocultar",
        "passwords_mismatch": "As senhas não coincidem.",
        "password_change_success": "Senha alterada com sucesso.",
        "password_change_error": "Erro ao alterar a senha.",
        "network_error_retry": "Erro de rede. Por favor, tente novamente."
    }
}